import React, { useEffect } from 'react'
import { BodyText } from '../../styles/global'
import { CenterText, SavingsText, LeftSection, RightSection, SavingsHeader, SavingsWrapper, ShortTermSavingGridBox, StoryBox } from './ShortTermSaving.styles'

export const ShortTermSaving = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
      <SavingsHeader>
            <LeftSection>
            <h3>
                    Short term savings
                    Designed to easily cultivate savings discipline
            </h3>
            </LeftSection>
            <RightSection>
                <img src="img/Frame 37.svg" alt="couple saving in a bottle" />
            </RightSection>
        </SavingsHeader>
        <CenterText>
            <h3>
                There are 4 sub plans to save with, you can start 
                cultivating a saving discipline with the daily, weekly, monthly or annual sub savings plans
            </h3>
        </CenterText>

        <ShortTermSavingGridBox>
        <StoryBox>
          <div>1</div>
          <h3>Daily Savings</h3>
          <p>
                are matured on the 15th day of your savings
          </p>
        </StoryBox>
        <StoryBox>
          <div>2</div>
          <h3>Weekly Savings</h3>
          <p>
                are matured on the 30th day of your savings
          </p>
        </StoryBox>
        <StoryBox>
          <div>3</div>
          <h3>Monthly Savings</h3>
          <p>
                are matured on the 120th day of your savings
          </p>
        </StoryBox>
        <StoryBox>
          <div>4</div>
          <h3>Yearly Savings</h3>
          <p>
                are matured on the 335th day of your savings
          </p>
        </StoryBox>
      </ShortTermSavingGridBox>

        <SavingsText>
            <BodyText style={{textAlign:"center"}}>
                    Monthly savings free withdrawals dates are April 1, August 1 and December 1 
                    For the annual savings, savings can be done on a daily, weekly, fortnightly and monthly basis.
            </BodyText>

        </SavingsText>
        </SavingsWrapper>
  )
}
